// removed by extract-text-webpack-plugin
module.exports = {"skip-btn":"k3FafTxDSkMbKYXNJTOBc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/create/tutorial/tutorial.scss
// module id = 1610
// module chunks = 0